module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.0c7d6207.svg";